import { render, staticRenderFns } from "./ScreeningsUpdateAmounts.vue?vue&type=template&id=09a62873&scoped=true&"
import script from "./ScreeningsUpdateAmounts.vue?vue&type=script&lang=js&"
export * from "./ScreeningsUpdateAmounts.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsUpdateAmounts.vue?vue&type=style&index=0&id=09a62873&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a62873",
  null
  
)

export default component.exports